import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["as", "key", "showIcon", "type"];
import React from 'react';
import classNames from 'classnames/bind';
import { arrayOf, bool, oneOf, shape, string } from 'prop-types';
import { BetaLabel } from "../../../icons";
import { TextBase } from "../../../internal/TextBase";
import { pointTypes, pointTypesEnum } from '../../constants';
import { NewWindowIcon } from '../NewWindowIcon';
import styles from './Menu.css';
var cx = classNames.bind(styles);

var renderPoint = function renderPoint(key, Component) {
  return /*#__PURE__*/React.createElement("li", {
    key: key,
    className: cx('item')
  }, Component);
};

var renderItem = function renderItem(item) {
  if (Array.isArray(item)) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.key,
      className: cx('group', 'group_multi')
    }, item.map(renderItem));
  }

  var Icon = item.Icon,
      isBeta = item.isBeta,
      key = item.key,
      points = item.points,
      text = item.text,
      title = item.title,
      href = item.href;
  return /*#__PURE__*/React.createElement("div", {
    key: key,
    className: cx('group')
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('heading')
  }, Icon && /*#__PURE__*/React.createElement("div", {
    className: cx('icon')
  }, /*#__PURE__*/React.createElement(Icon, {
    height: 20,
    width: 20
  })), title && /*#__PURE__*/React.createElement("a", {
    className: cx('item_button'),
    href: href
  }, title), isBeta && /*#__PURE__*/React.createElement("div", {
    className: cx('beta')
  }, /*#__PURE__*/React.createElement(BetaLabel, null))), text && /*#__PURE__*/React.createElement("div", {
    className: cx('text')
  }, /*#__PURE__*/React.createElement(TextBase, null, text)), points && points.length > 0 && /*#__PURE__*/React.createElement("ul", {
    className: cx('group_list')
  }, points.map(function (_ref, index) {
    var _renderByType;

    var Component = _ref.as,
        pointKey = _ref.key,
        showIcon = _ref.showIcon,
        type = _ref.type,
        point = _objectWithoutProperties(_ref, _excluded);

    var componentKey = pointKey || "point-".concat(index);

    if (Component) {
      return renderPoint(componentKey, /*#__PURE__*/React.createElement(Component, _extends({
        className: cx('item_link')
      }, point)));
    }

    var renderByType = (_renderByType = {}, _defineProperty(_renderByType, pointTypesEnum.link, /*#__PURE__*/React.createElement("a", _extends({
      className: cx('item_link')
    }, point), point.title, showIcon && /*#__PURE__*/React.createElement(NewWindowIcon, null))), _defineProperty(_renderByType, pointTypesEnum.button, /*#__PURE__*/React.createElement("a", _extends({
      className: cx('item_button')
    }, point), point.icon && /*#__PURE__*/React.createElement("span", {
      className: cx('item_button_icon')
    }, /*#__PURE__*/React.createElement(point.icon, {
      height: 20,
      width: 20
    })), point.title, showIcon && /*#__PURE__*/React.createElement(NewWindowIcon, null))), _defineProperty(_renderByType, pointTypesEnum.text, /*#__PURE__*/React.createElement(TextBase, {
      color: "N100",
      size: "l"
    }, point.title)), _renderByType);
    return renderPoint(componentKey, renderByType[type || 'Link']);
  })));
};

export var Menu = function Menu(props) {
  var _cx;

  var items = props.items,
      isPromo = props.isPromo,
      theme = props.theme;
  return /*#__PURE__*/React.createElement("div", {
    className: cx('links', (_cx = {}, _defineProperty(_cx, "theme_".concat(theme), theme), _defineProperty(_cx, "promo", isPromo), _cx))
  }, items.map(renderItem));
};
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  isPromo: bool,
  // eslint-disable-line react/boolean-prop-naming
  items: arrayOf(shape({
    title: string,
    key: string,
    points: arrayOf(shape({
      title: string,
      key: string,
      href: string,
      showIcon: bool,
      type: oneOf(pointTypes)
    }))
  })),
  theme: string
} : {};